import { Flex, Text } from "@chakra-ui/react";
import { DurationDistance } from "~/generated/graphql.types";

export const SpotStatsSummary = ({
  allSpotStats,
}: {
  allSpotStats: DurationDistance[];
}) => {
  const totalDistance = (
    allSpotStats.reduce((p, c) => p + c.distance, 0) / 1000
  ).toFixed(2);
  const totalDuration = (
    allSpotStats.reduce((p, c) => p + c.duration, 0) / 60
  ).toFixed(1);
  return (
    <Flex
      ml={0}
      alignItems="baseline"
      mt={4}
      borderBottom={"solid 1px"}
      data-testid={"spot-stats-summary"}
    >
      <Text ml={2}>合計</Text>
      <Text ml={2} as="b">
        {allSpotStats.length}
      </Text>
      <Text ml={1} mr={2} fontSize="xs">
        スポット
      </Text>
      <Text as="b">{totalDistance}</Text>
      <Text ml={1} fontSize="xs">
        km
      </Text>
      <Text ml={2} as="b">
        {totalDuration}
      </Text>
      <Text ml={1} fontSize="xs">
        分
      </Text>
    </Flex>
  );
};
